import "./media.less";
import { debounce } from "lodash";
import {useLayoutEffect, useRef, useState } from "react";

function measurementToPixels(measurement: string|undefined|null): number {
  if (measurement === null || typeof measurement !== "string") {
    return 0
  }
  if (/px$/.test(measurement)) {
    const raw = measurement.replace("px", "")
    const num = Number(raw)
    return isNaN(num) ? 0 : num;
  } else {
    console.log("failed to parse %s as number", measurement)
    return 0
  }
}

export default function YouTube(props: { url: string, start?: number, end?: number, toggleZoom(): void, isZoomed: boolean }) {
  const toggleZoom = props.toggleZoom;
  const mediaRef = useRef<HTMLDivElement>(null);
  const start = props.start || 0;
  const end = props.end || 0;
  const isZoomed = props.isZoomed;
  const origin = encodeURIComponent(`${location.protocol}//${location.host}`);
  const url = `${props.url}?autoplay=0&mute=0&controls=1&start=${start}&end=${end}&origin=${origin}&playsinline=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&loop=1&fs=0&enablejsapi=1`
  const [state, setState] = useState({
    containerWidth: 0,
    containerHeight: 0,
    videoWidth: 0,
    videoHeight: 0,
    videoX: 0,
    videoY: 0,
  })
  
  const ratio = 16/9

  useLayoutEffect(() => {
    function layout(){
      if (!mediaRef.current) {
        console.log("no video element")
        return;
      }

      const el = mediaRef.current
      const elStyle = window.getComputedStyle(el)
      const marginWidth = measurementToPixels(elStyle.marginLeft) + measurementToPixels(elStyle.marginRight)
      const marginHeight = measurementToPixels(elStyle.marginTop) + measurementToPixels(elStyle.marginBottom)
      const videoPaddingWidth = paddingLeft + paddingRight; //measurementToPixels(elStyle.paddingLeft) + measurementToPixels(elStyle.paddingRight)
      const videoPaddingHeight = paddingTop + paddingBottom; //measurementToPixels(elStyle.paddingTop) + measurementToPixels(elStyle.paddingBottom)
      
      if (!el.parentElement) {
        console.warn("no parent element for ", el)
        return
      }
      
      const p = el.parentElement
      const parentStyle = window.getComputedStyle(p);
      const parentSize = p.getBoundingClientRect();
      const parentPaddingWidth = measurementToPixels(parentStyle.paddingLeft) + measurementToPixels(parentStyle.paddingRight);
      const parentPaddingHeight = measurementToPixels(parentStyle.paddingTop) + measurementToPixels(parentStyle.paddingBottom);
      
      let containerWidth = Math.min(parentSize.width, window.innerWidth) - (parentPaddingWidth + marginWidth);
      let containerHeight = Math.min(parentSize.height, window.innerHeight) - (parentPaddingHeight + marginHeight);
      
      let maxVideoWidth = containerWidth - videoPaddingWidth
      let maxVideoHeight = containerHeight - videoPaddingHeight
      
      // start by width
      let videoWidth = maxVideoWidth;
      let videoHeight = (1/ratio) * videoWidth;
      
      // clip height
      if (videoHeight > maxVideoHeight) {
        videoHeight = maxVideoHeight
        videoWidth = ratio * videoHeight
      }
      
      // center
      let videoX = paddingLeft + (maxVideoWidth - videoWidth) / 2;
      let videoY = paddingTop + (maxVideoHeight - videoHeight) / 2;
      
      // console.log("layout video")
      
      setState({
        containerWidth,
        containerHeight,
        videoWidth,
        videoHeight,
        videoX,
        videoY
      })
    }

    layout();
    
    const deboucedLayout = debounce(layout, 100, {leading: true})
    
    window.addEventListener("resize", deboucedLayout)
    
    return () => {
      window.removeEventListener("resize", deboucedLayout)
    }
  }, [isZoomed])
  
  const paddingTop = 15
  const paddingLeft = 5
  const paddingRight = 5
  const paddingBottom = 5

  return (
    <div className="media"  ref={mediaRef} style={{
      width: "100%",
      height: "100%",
      position: "relative",
      padding: 0
    }}>
      <div style={{
        position: "absolute",
        top: state.videoY,
        left: state.videoX,
        width: state.videoWidth,
        height: state.videoHeight,
        
      }}>
        <iframe
          title="YouTube video player"
          src={url}
          width={state.videoWidth} height={state.videoHeight}
          frameBorder="0">
        </iframe>
        <button className="zoom" onClick={toggleZoom} />
      </div>
    </div>
  )
}